module.exports = __webpack_public_path__ + "static/media/centro_medio_2.ecf86246.jpg";